import { signal } from "@preact/signals";

type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
};

export const installPromptEvent = signal<BeforeInstallPromptEvent | null>(null);

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    installPromptEvent.value = e as BeforeInstallPromptEvent;
  });
  window.addEventListener("appinstalled", () => {
    installPromptEvent.value = null;
  });
}

export async function promptInstall(): Promise<void> {
  const ev = installPromptEvent.value;
  if (!ev) return;
  await ev.prompt();
  await ev.userChoice;
  installPromptEvent.value = null;
}
